export default __webpack_public_path__ + "static/media/extortion-active.05280b6f.svg";